module.exports = __webpack_public_path__ + "static/media/sofa-4.e7ff89d0.png";